import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneCRMPayload } from '@app-store/slices/crm/one'

interface TaskAction extends Action {
    payload: IOneCRMPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.crm.one

function* getOneCRMSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/integrations/crms/one/${payload.crmId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getOneCRMSaga(): any {
    yield takeLatest<TaskAction>(onRequest, getOneCRMSagaTask)
}

export default getOneCRMSaga
